









// import Vue, { PropType } from 'vue';
import Vue from 'vue';

// interface DataType {
//   innerValue: boolean;
//   resolvePromise?: any;
//   rejectPromise?: any;
// }

export default Vue.extend({
  name: 'g-trasition-dialog',
  // // data(): DataType {
  // //   return {
  // //     innerValue: false,
  // //     resolvePromise: undefined,
  // //     rejectPromise: undefined,
  // //   };
  // // },
  // props: {
  //   // text: {
  //   //   type: String as PropType<string>,
  //   //   required: true,
  //   // },
  //   // value: {
  //   //   type: Boolean as PropType<boolean>,
  //   //   default: false,
  //   // },
  //   // okLabel: {
  //   //   type: String as PropType<string>,
  //   //   required: true,
  //   // },
  //   // cancelLabel: {
  //   //   type: String as PropType<string>,
  //   //   required: true,
  //   // },
  // },
  // computed: {
  //   innterText(): string {
  //     return this.text.replace(/\\n/g, "\n");
  //   }
  // },
  methods: {
    async show(): Promise<boolean> {
      const r = await (this.$refs.dialog as any).show();
      return r;
    },
    // onComfirm() {
    //   this.innerValue = false;
    //   this.$emit('confirm');
    //   if (this.resolvePromise) {
    //     this.resolvePromise(true);
    //   }
    // },
    // onCancel() {
    //   this.innerValue = false;
    //   this.$emit('cancel');
    //   if (this.rejectPromise) {
    //     this.rejectPromise(false);
    //   }
    // },
  },
});
